import React from "react";
import { serverHost } from "variables/serverdata";
import { getAuthToken } from "views/pages/hucs/util/helpers";

export default function useHrmsProxyStatusPoll(siteUuid, { enabled = true, intervalMs = 60000 } = {}) {
  const timerRef = React.useRef(null);

  React.useEffect(() => {
    if (!enabled || !siteUuid) return;

    let cancelled = false;

    const fetchStatusOnce = async () => {
      try {
        const token = getAuthToken();
        const res = await fetch(`${serverHost}/hrms/proxy/status/${siteUuid}`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        if (res.status === 404) {
          const payload = { online: false, last_checkin: null, is_offline: true };
          localStorage.setItem("hrmsProxyStatus", JSON.stringify({ siteUuid, ...payload, ts: Date.now() }));
          window.dispatchEvent(new CustomEvent("hrmsProxyStatusUpdated", { detail: { siteUuid, ...payload } }));
          return;
        }

        if (!res.ok) throw new Error(`Proxy status fetch failed: ${res.status}`);

        const data = await res.json();
        if (cancelled) return;

        localStorage.setItem("hrmsProxyStatus", JSON.stringify({ siteUuid, ...data, ts: Date.now() }));
        window.dispatchEvent(new CustomEvent("hrmsProxyStatusUpdated", { detail: { siteUuid, ...data } }));
      } catch (e) {
        const payload = { online: false, last_checkin: null, is_offline: true };
        localStorage.setItem("hrmsProxyStatus", JSON.stringify({ siteUuid, ...payload, ts: Date.now() }));
        window.dispatchEvent(new CustomEvent("hrmsProxyStatusUpdated", { detail: { siteUuid, ...payload } }));
        console.debug("Proxy status poll error:", e);
      }
    };

    fetchStatusOnce();
    timerRef.current = setInterval(fetchStatusOnce, intervalMs);

    return () => {
      cancelled = true;
      if (timerRef.current) clearInterval(timerRef.current);
      timerRef.current = null;
    };
  }, [enabled, siteUuid, intervalMs]);
}